/**
 * The class the `dark` Tailwind variant matches (see `packages/design-system/src/styles/design-system.css`).
 *
 * This is the whole colour-scheme API. There is deliberately no provider, no stored preference and
 * no `prefers-color-scheme` handling: which surfaces are dark is a design decision taken per page
 * or per region, not something the user toggles. Put this class on whatever ancestor bounds the
 * dark region and every DS component beneath it follows, because the variant matches `.dark *`.
 */
export const DARK_CLASS = 'dark';

/**
 * Marks a region as explicitly LIGHT, bounding an enclosing dark one.
 *
 * No CSS matches this class, and none should: the token layer's variant is written `:where(.dark) &`,
 * and a descendant selector cannot express "the nearest marked ancestor wins". So this is a marker
 * for JavaScript to stop at, not a style hook — `useInheritedDarkMode` is its only consumer.
 *
 * It exists because a light region nested inside a dark one is a real shape: seven of them are modals
 * over the dark live room (`StartNatteringContainer`, `EndEvent`, `RecordingButton`, …). That used to
 * be harmless, because such a modal portalled to `<body>` and escaped the dark class on its way out.
 * `Dialog` now carries the ambient scheme across the portal deliberately, so the escape is gone and
 * the light region has to be able to say so.
 *
 * Emitted by `DsColorScheme` in `common/hocs/withTheme`, alongside MUI's own `mode`.
 */
export const LIGHT_CLASS = 'ds-light';
